'use strict';

var NAME           = 'flip-card';
var NAMESPACE      = 'hogo.' + NAME;
var SELECTOR       = '[data-' + NAME + ']';
var FLIPPED_CLASS  = 'flipped';

var $body = $(document.body);

/**
 * Constructor.
 *
 * @param  {DOMElement|string}  element
 * @param  {object}             options
 */
var FlipCard = function (element, options)
{
    this.$element = $(element);
};

FlipCard.VERSION = '0.1.0';

/**
 * Initiate the toggle (on/off).
 *
 * @param  {object}  e
 */
FlipCard.prototype.toggle = function (e)
{
    this.$element.toggleClass(FLIPPED_CLASS);
}

/**
 * Deactivate all active toggles.
 */
FlipCard.prototype.show = function ()
{
    this.$element.addClass(FLIPPED_CLASS);
}

/**
 * Flips the card back to the front.
 */
FlipCard.prototype.hide = function ()
{
    this.$element.removeClass(FLIPPED_CLASS);
}

/**
 * Flips any cards that are currently flipped back to the front. Does not
 * apply to any cards that are the target of the click.
 */
FlipCard.prototype.hideAll = function (e)
{
    var $target = $(e.target);

    $(SELECTOR).each(function () {

        // Clicking inside this card.
        if ($.contains(this, e.target)) {
            return;
        }

        $(this).data(NAMESPACE).hide();

    });


}


// FLIP CARD PLUGIN DEFINITION
// ===========================

function Plugin (option)
{

    var args = [];
    for (var i = 1; i < arguments.length; i++) {
        args.push(arguments[i]);
    }

    return this.each(function () {
        var $this = $(this);
        var data  = $this.data(NAMESPACE);

        if ( ! data) $this.data(NAMESPACE, (data = new FlipCard(this)));
        if (typeof option === 'string') data[option].apply(data, args);
    });
}

$.fn.flipCard             = Plugin;
$.fn.flipCard.Constructor = FlipCard;


// APPLY TO STANDARD SPINNER ELEMENTS
// ==================================

$(SELECTOR).flipCard();


// BIND EVENTS
// ===========

$(document)
    .on('click.' + NAMESPACE, FlipCard.prototype.hideAll)
    .on('click.' + NAMESPACE, SELECTOR, function () {
        Plugin.call($(this), 'show');
    });


// EXPORT MODULE
// =============

export default FlipCard;